import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=231fd49a&"
import script from "./Modal.ts?vue&type=script&lang=ts&"
export * from "./Modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports